







import { Component, Vue } from 'vue-property-decorator';
import {successButtonColorClass} from '@/utlitities/color';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
  },
})
export default class StSettingsSeparator extends Vue {

}
